import React from 'react';
import { XIcon } from 'lucide-react';
import { pains } from '../data/pains';
export function PainGrid() {
  return <section aria-labelledby="pains-heading" className="w-full bg-cream" data-id="element-173" data-mp="1zggjj1h8xu6k">
      <div className="max-w-5xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-id="element-174" data-mp="1uo6wbt7in87z">
        <h2 id="pains-heading" className="font-serif font-bold text-ink text-2xl sm:text-3xl lg:text-4xl leading-snug max-w-3xl" data-id="element-175" data-mp="1umcc6h42jk4y">
          If you already homeschool, at least one of these is going to sound
          uncomfortably familiar:
        </h2>

        <ul className="mt-9 grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-1" data-id="element-176" data-mp="1gnmg94szjqi6">
          {pains.map(pain => <li key={pain} className="flex gap-3 py-4 border-b border-cream-dark" data-id="element-177" data-mp="1brnu7nv4qkkx">
              <XIcon className="w-[18px] h-[18px] mt-[3px] text-danger shrink-0" aria-hidden="true" data-id="element-178" data-mp="364dpa8x8hztw" />
              <p className="text-[15px] sm:text-base leading-relaxed text-ink-soft" data-id="element-179" data-mp="3231wjuj2cyhh">
                {pain}
              </p>
            </li>)}
        </ul>

        <p className="mt-10 font-serif text-lg sm:text-xl text-ink leading-relaxed max-w-3xl" data-id="element-180" data-mp="3l8g5vakw6042">
          What if every one of those had already been designed around — not with
          more discipline, but with a system that expects the week to go
          sideways?
        </p>
      </div>
    </section>;
}